/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskLogEntryData,
    TaskLogEntryDataFromJSON,
    TaskLogEntryDataFromJSONTyped,
    TaskLogEntryDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskLogEntry
 */
export interface TaskLogEntry {
    /**
     * 
     * @type {TaskLogEntryData}
     * @memberof TaskLogEntry
     */
    data: TaskLogEntryData;
    /**
     * 
     * @type {number}
     * @memberof TaskLogEntry
     */
    marker: number;
    /**
     * 
     * @type {number}
     * @memberof TaskLogEntry
     */
    timestamp: number;
}

export function TaskLogEntryFromJSON(json: any): TaskLogEntry {
    return TaskLogEntryFromJSONTyped(json, false);
}

export function TaskLogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskLogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': TaskLogEntryDataFromJSON(json['data']),
        'marker': json['marker'],
        'timestamp': json['timestamp'],
    };
}

export function TaskLogEntryToJSON(value?: TaskLogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TaskLogEntryDataToJSON(value.data),
        'marker': value.marker,
        'timestamp': value.timestamp,
    };
}


